import React, { PropsWithChildren, ReactNode } from 'react';
import classNames from 'classnames';
import * as styles from './StructuredListItem.module.scss';
import { Inline } from 'components/layout';

export type StructuredListItemProps = {
  icon: ReactNode;
  primaryAction?: ReactNode;
} & React.HTMLAttributes<HTMLLIElement>;

export const StructuredListItem = ({
  children,
  className,
  primaryAction,
  icon,
  ...props
}: PropsWithChildren<StructuredListItemProps>) => {
  return (
    <Inline
      component="li"
      alignX="left"
      alignY="center"
      shouldWrap={false}
      spacing={4}
      className={classNames(styles.item, className)}
      {...props}
    >
      {icon}
      <Inline spacing={2} alignX="spaceBetween" className={styles.itemContent}>
        {children}
      </Inline>
      {primaryAction && (
        <div className={styles.primaryAction}>{primaryAction}</div>
      )}
    </Inline>
  );
};
